"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _constants$ProductTyp, _constants$ProductTyp2, _CreditErrorMessageBy, _constants$ProductTyp3, _constants$ProductTyp4, _errorEvents;

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInvalidCreditError = void 0;

var _react = require("react");

var _identity = _interopRequireDefault(require("ramda/src/identity"));

var _mocks = require("../../../mocks");

var _constants = require("../../../constants");

var _utils = require("../../../utils");

var _services = require("../../../services");
/* eslint-disable react-hooks/exhaustive-deps */


var CreditErrorMessageByProduct = (_CreditErrorMessageBy = {}, _defineProperty(_CreditErrorMessageBy, _constants.ProductTypes.AUTO, (_constants$ProductTyp = {}, _defineProperty(_constants$ProductTyp, _constants.ValidationTypes.MIN, {
  title: 'Ops! Valor insuficiente',
  description: "Empr\xE9stimos com carro em garantia exigem valor min\xEDmo de ".concat((0, _utils.formatCurrency)(_mocks.CreditRangeByProduct[_constants.ProductTypes.AUTO].min, true))
}), _defineProperty(_constants$ProductTyp, _constants.ValidationTypes.MAX, {
  title: 'Ops! Valor excedido',
  description: "Valor m\xE1ximo de ".concat((0, _utils.formatCurrency)(_mocks.CreditRangeByProduct[_constants.ProductTypes.AUTO].max, true), " para empr\xE9stimos com carro em garantia")
}), _constants$ProductTyp)), _defineProperty(_CreditErrorMessageBy, _constants.ProductTypes.HOME, (_constants$ProductTyp2 = {}, _defineProperty(_constants$ProductTyp2, _constants.ValidationTypes.MIN, {
  title: 'Ops! Valor insuficiente',
  description: "Empr\xE9stimos com im\xF3vel em garantia exigem valor min\xEDmo de ".concat((0, _utils.formatCurrency)(_mocks.CreditRangeByProduct[_constants.ProductTypes.HOME].min, true))
}), _defineProperty(_constants$ProductTyp2, _constants.ValidationTypes.MAX, {
  title: 'Ops! Valor excedido',
  description: "Valor m\xE1ximo de ".concat((0, _utils.formatCurrency)(_mocks.CreditRangeByProduct[_constants.ProductTypes.HOME].max, true), " para empr\xE9stimos com im\xF3vel em garantia")
}), _constants$ProductTyp2)), _CreditErrorMessageBy);

var getValidationType = function getValidationType(value, productType) {
  if (value < _mocks.CreditRangeByProduct[productType].min) {
    return _constants.ValidationTypes.MIN;
  }

  if (value > _mocks.CreditRangeByProduct[productType].max) {
    return _constants.ValidationTypes.MAX;
  }

  return null;
};

var errorEvents = (_errorEvents = {}, _defineProperty(_errorEvents, _constants.ProductTypes.AUTO, (_constants$ProductTyp3 = {}, _defineProperty(_constants$ProductTyp3, _constants.ValidationTypes.MIN, _services.dispatchAutoInsufficientValueEvent), _defineProperty(_constants$ProductTyp3, _constants.ValidationTypes.MAX, _services.dispatchAutoExceededValueEvent), _constants$ProductTyp3)), _defineProperty(_errorEvents, _constants.ProductTypes.HOME, (_constants$ProductTyp4 = {}, _defineProperty(_constants$ProductTyp4, _constants.ValidationTypes.MIN, _services.dispatchHomeInsufficientValueEvent), _defineProperty(_constants$ProductTyp4, _constants.ValidationTypes.MAX, _services.dispatchHomeExceededValueEvent), _constants$ProductTyp4)), _errorEvents);

var useInvalidCreditError = function useInvalidCreditError(value, productType) {
  var validationType = getValidationType(value, productType);
  var messages = CreditErrorMessageByProduct[productType][validationType];
  (0, _react.useEffect)(function () {
    var dispatchEvent = errorEvents[productType][validationType] || _identity.default;
    dispatchEvent();
  }, []);
  return {
    validationType: validationType,
    messages: messages
  };
};

exports.useInvalidCreditError = useInvalidCreditError;